// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2KEYE","infected":"Cards_infected__rd3mV","recovered":"Cards_recovered__2D9rq","deaths":"Cards_deaths__2xlsW"};